import { useModules } from '@contexts/modules-provider';
import { usePermissions } from '@contexts/permissions-provider';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import { ErrorPage } from '@shared/components/error-pages/ErrorPage';
import * as React from 'react';

import { AppShell } from './components/app-shell/AppShell';

const AppLayout = React.memo((): React.ReactElement => {
  const { isModulesLoading } = useModules();
  const {
    permissions,
    isLoading: isPermissionsLoading,
    isError: isPermissionsError,
  } = usePermissions();

  if (isPermissionsLoading || isModulesLoading) {
    return <AppLoader />;
  }

  // Security gate: if permissions failed or loaded empty, something is wrong.
  // All users (Train, Instruct, Manage, Visitor) should have permissions.
  const hasNoPermissions = permissions.length === 0;

  if (isPermissionsError || hasNoPermissions) {
    return <ErrorPage type="internal-server-error" />;
  }

  return <AppShell />;
});

AppLayout.displayName = 'AppLayout';

export { AppLayout };
